import { BreakpointsOptions } from '@mui/material/styles';

import { spacing } from './spacing';

const GUTTER = spacing(3);

// The phone layout runs at 800px and below, matching Tradehaus (`@media (max-width: 800px)`).
// Width checks in code use `width <= MOBILE_MAX_WIDTH`; `theme.breakpoints.down('md')` is the same cutoff.
export const MOBILE_MAX_WIDTH = 800;

export const breakpoints = {
  values: {
    // Mobile
    // - iPhone Pro (393 x 852)
    // - iPhone Pro Max (428 x 926)
    sm: 0,
    // Desktop from 801px; down('md') is max-width 800.95px
    md: MOBILE_MAX_WIDTH + 1,
    // Desktop
    // - Studio Display (2560 x 1440)
    lg: 2060 + GUTTER * 2,
  },
} as BreakpointsOptions;
